module.exports = __webpack_public_path__ + "img/lecce_background_hero.21dbf31f.png";